import { render } from "./PlayerFull.vue?vue&type=template&id=22e2eed7&scoped=true&ts=true"
import script from "./PlayerFull.vue?vue&type=script&lang=ts"
export * from "./PlayerFull.vue?vue&type=script&lang=ts"

import "./PlayerFull.vue?vue&type=style&index=0&id=22e2eed7&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e2eed7"]])

export default __exports__